import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const Container = styled.i`
  color: darkgray;
`;
const EmptyValue = () => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(Container, null, t("common_views.empty_value"));
};
export default EmptyValue;
